import type { Warehouse } from '~/types/warehouse'

const channelKey = 'channel'
const globalChannelKey = 'global-channel'
const warehousesKey = 'warehouses'

export function useChannel() {
  const channel = useState<string | null>(
    channelKey,
    () => useCookie(channelKey, { sameSite: true, secure: true })?.value || null
  )

  const globalChannel = useState<string | null>(
    globalChannelKey,
    () => useCookie(globalChannelKey, { sameSite: true, secure: true })?.value || null
  )

  const warehouses = useState<string | null>(
    warehousesKey,
    () => useCookie(warehousesKey, { sameSite: true, secure: true })?.value || null
  )

  const setChannel = (value: string | null) => {
    const newValue = channel.value !== value ? value : null
    channel.value = newValue
    useCookie(channelKey, { sameSite: true, secure: true }).value = newValue
  }

  const setGlobalChannel = (value: string | null) => {
    const newValue = globalChannel.value !== value ? value : null
    globalChannel.value = newValue
    useCookie(globalChannelKey, { sameSite: true, secure: true }).value = newValue
  }

  const setWarehouses = (value: Warehouse[] | [] | null) => {
    const newValue = warehouses.value !== value ? value : null
    warehouses.value = JSON.stringify(newValue)
    useCookie(warehousesKey, { sameSite: true, secure: true }).value = newValue
  }

  return {
    channel,
    globalChannel,
    warehouses,
    setChannel,
    setWarehouses,
    setGlobalChannel,
  }
}
